<template>
  <div class="ops-pagination">
    <el-button-group>
      <el-button
        type="primary"
        icon="el-icon-arrow-left"
        size="mini"
        :disabled="disabledObject.prev"
        @click="prev"
      >
        上一页
      </el-button>
      <el-button
        type="primary"
        size="mini"
        :disabled="disabledObject.next"
        @click="next"
      >
        下一页<i class="el-icon-arrow-right el-icon--right"></i>
      </el-button>
    </el-button-group>
  </div>
</template>

<script>
export default {
  name: 'Pagination',

  props: {
    disabled: {
      type: Boolean | Object,
      default: true,
    },
  },

  computed: {
    disabledObject() {
      if (typeof this.disabled === 'boolean') {
        return {
          prev: this.disabled,
          next: this.disabled,
        }
      } else if (typeof this.disabled === 'object') {
        return {
          prev: !!this.disabled.prev,
          next: !!this.disabled.next,
        }
      } else {
        return {}
      }
    },
  },

  methods: {
    prev() {
      this.$emit('prev')
    },

    next() {
      this.$emit('next')
    },
  },
}
</script>

<style lang="scss">
.ops-pagination {
  text-align: right;
  padding-top: 10px;
}
</style>
